export default {
  SESSIONS: 'sessions',
  REDIRECT: 'redirect',
  COMPANIES: 'companies',
};
